/* eslint-disable react/no-danger */
import React, { useMemo } from "react";
import {
  Button,
  buttonThemes,
  componentSizes
} from "@streeteasy/design-system";
import { string } from "prop-types";
import sanitizeHtml from "sanitize-html";

import * as S from "./styled";

const SlideToggle = ({ fullContent, initialContent }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleClick = () => setIsExpanded(!isExpanded);

  const sanitizedInitialContent = useMemo(() => sanitizeHtml(initialContent), [
    initialContent
  ]);

  const sanitizedFullContent = useMemo(() => sanitizeHtml(fullContent), [
    fullContent
  ]);

  const fullContentWrapperId = "full-content";

  return fullContent.length > initialContent.length ? (
    <S.Container>
      <S.InitialContentWrapper
        dangerouslySetInnerHTML={{ __html: sanitizedInitialContent }}
        isVisible={!isExpanded}
      />
      <S.FullContentWrapper
        dangerouslySetInnerHTML={{
          __html: sanitizedFullContent
        }}
        id={fullContentWrapperId}
        isVisible={isExpanded}
      />
      <S.ButtonWrapper>
        <Button
          aria-controls={fullContentWrapperId}
          aria-expanded={isExpanded}
          onClick={handleClick}
          size={componentSizes.SM}
          theme={buttonThemes.SECONDARY}
          type="button"
        >
          {isExpanded ? "HIDE FULL DESCRIPTION" : "READ FULL DESCRIPTION"}
        </Button>
      </S.ButtonWrapper>
    </S.Container>
  ) : (
    <div dangerouslySetInnerHTML={{ __html: sanitizedInitialContent }} />
  );
};

SlideToggle.propTypes = {
  initialContent: string.isRequired,
  fullContent: string.isRequired
};

export default SlideToggle;
